import HubSearchBar from 'components/SearchBar/HubSearchBar';
import React, { useState } from 'react';

function FAQHubBanner({ title, onSearch }) {
  const [searchInput, setSearchInput] = useState('');
  return (
    <>
      <div className="faq_hub_banner">
        <div className="content_container">
          <div>
            <h2 className="title">{title}</h2>
            <div className="search_bar_container">
              <HubSearchBar
                value={searchInput}
                onChange={(val) => setSearchInput(val)}
                placeholder={'Search for a question or topic'}
                onClickSearch={() => onSearch(searchInput)}
              />
            </div>
            <p className="description">
              You can also browse the topics below to find what you’re looking
              for
            </p>
          </div>
        </div>
      </div>
      <style jsx>{`
        .description {
          font-family: 'Roboto-Medium';
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: center;
          color: #e4e4e4;
          margin-top: 24px;
        }
        .content_container {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(4, 4, 4, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .search_bar_container {
          display: flex;
          justify-content: center;
          margin-top: 24px;
        }
        .title {
          font-family: 'big_noodle_titling';
          font-size: 39px;
          font-weight: 400;
          line-height: 48px;
          letter-spacing: 0em;
          text-align: center;
          padding: 0;
          margin: 0;
          color: #e4e4e4;
        }
        .faq_hub_banner {
          height: 400px;
          background-image: url('/images/hypergate-banner.png');
          background-repeat: no-repeat;
          background-size: cover;
          backround-position: center;
          border-radius: 4px;
          overflow: hidden;
          position: relative;
        }
        @media (width<=640px) {
          .content_container {
            padding: 0 16px;
          }
        }
      `}</style>
    </>
  );
}

export default FAQHubBanner;
